import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React from 'react';
import classNames from 'classnames';
import { darken, lighten } from '@material-ui/core/styles/colorManipulator';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: 4,
      width: 185,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: 16,
      margin: '0 8px',
      cursor: 'pointer',
      backgroundColor: theme.palette.background.paper,
      '&:hover': {
        backgroundColor: theme.palette.type === 'light' ? lighten(theme.palette.primary.light, 0.9) : darken(theme.palette.primary.dark, 0.5),
        borderColor: theme.palette.type === 'light' ? theme.palette.primary.light : theme.palette.primary.dark
      }
    },
    selected: {
      backgroundColor: theme.palette.type === 'light' ? lighten(theme.palette.primary.light, 0.9) : darken(theme.palette.primary.dark, 0.5),
      borderColor: theme.palette.type === 'light' ? theme.palette.primary.light : theme.palette.primary.dark
    }
  })
);

interface Props {
  children: React.ReactNode;
  selected?: boolean;
  onClick: () => void;
}

function ButtonPanel(props: Props) {
  const { children, selected, onClick } = props;
  const classes = useStyles({});
  return (
    <div className={selected ? classNames(classes.root, classes.selected) : classes.root} onClick={onClick}>
      {children}
    </div>
  );
};

export default ButtonPanel;
